import { useCallback } from "react";

import { Parking2 } from "../../services";
import { useTypedSelector } from "../../redux/store";
import { sortByNumberOrString } from "../../utils";
import { ColumnId } from "../../constants/tables/orderWidgetParkings";

import { isLimit, isOrder } from ".";

const useParkingSubHandler = (): useParkingSubHandler.Props => {
	const lang = useTypedSelector((state) => state.session.language);

	const getOrderAndLimitParkingSubHandler = useCallback(
		(
			data: useParkingSubHandler.SmallSubscribeOptions,
			roleSubscribe: Parking2.Model[],
		): Parking2.Model[] => {
			const { limit, order } = data;

			if (!Array.isArray(roleSubscribe)) {
				return [];
			}

			let retval = [...(roleSubscribe || [])];

			if (isOrder(order)) {
				const [[dataKey, sortType] = []] = Object.entries(order || {});
				const isSort =
					typeof sortType === "string" &&
					typeof dataKey === "string" &&
					["asc", "desc"].includes(sortType.toLowerCase());

				if (isSort) {
					const isAscending = sortType.toLowerCase() === "asc";
					const sortOrder = isAscending ? 1 : -1;

					if (dataKey === ColumnId.Name) {
						const sort = retval.sort((prev, next) => {
							const prevValue = prev?.name?.[lang] ?? "";
							const nextValue = next?.name?.[lang] ?? "";
							return (
								sortByNumberOrString(prevValue, nextValue) *
								sortOrder
							);
						});

						retval = sort;
					}

					if (dataKey === ColumnId.DriversAmount) {
						const sort = retval.sort((prev, next) => {
							const prevValue = prev.executorsQueue?.length ?? 0;
							const nextValue = next.executorsQueue?.length ?? 0;
							return (
								sortByNumberOrString(prevValue, nextValue) *
								sortOrder
							);
						});

						retval = sort;
					}

					if (dataKey === ColumnId.Aliases) {
						const sort = retval.sort((prev, next) => {
							const prevValue =
								prev?.executorsQueue?.[0]?.executor?.callSign
									?.toString()
									?.toLowerCase() ?? "";
							const nextValue =
								next?.executorsQueue?.[0]?.executor?.callSign
									?.toString()
									?.toLowerCase() ?? "";
							return (
								sortByNumberOrString(prevValue, nextValue) *
								sortOrder
							);
						});

						retval = sort;
					}
				}
			}

			if (isLimit(limit)) {
				retval = retval.slice(0, limit);
			}

			return retval;
		},
		[lang],
	);

	return {
		getOrderAndLimitParkingSubHandler,
	};
};

declare namespace useParkingSubHandler {
	interface Props {
		getOrderAndLimitParkingSubHandler: (
			data: SmallSubscribeOptions,
			roleSubscribe: Parking2.Model[],
		) => Parking2.Model[];
	}

	interface SmallSubscribeOptions {
		order?: Parking2.Order;
		limit?: number;
	}
}

export default useParkingSubHandler;
